import React from 'react'

type ButtonProps = {
  children: React.ReactNode
  className?: string
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
}

const Button = ({ children, className = '', onClick, type = 'button' }: ButtonProps) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`bg-[#744DFF] text-white px-5 py-3 font-semibold text-lg rounded-full hover:opacity-90 transition duration-200 ${className}`}
    >
      {children}
    </button>
  )
}

export default Button
